export default __webpack_public_path__ + "static/media/ic_person_48px.ecba06fc.svg";